import React, {Component, PropTypes} from 'react'
import {Row, Col, Card, Button} from 'react-materialize';

import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import law from '../../images/law.png';

import {CSVLink} from "react-csv";
import electrocution from "../../images/electrocution.png";

import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';
import {injectIntl, intlShape} from 'react-intl';
import DatePicker from "react-datepicker";

class ChecklistMulher extends Component{

    constructor(props){
        super(props);

        this.handleDownloadPDF= this.handleDownloadPDF.bind(this);


        this.showDiv37= this.showDiv37.bind(this);
        this.showDiv38= this.showDiv38.bind(this);
        this.showDiv39= this.showDiv39.bind(this);
        this.showDiv40= this.showDiv40.bind(this);
        this.showDiv41= this.showDiv41.bind(this);
        this.showDiv42= this.showDiv42.bind(this);

        this.state={
            showComponent37: false, /*mulher*/
            showComponent38: false,
            showComponent39: false,
            showComponent40: false,
            showComponent41: false,
            showComponent42: false,

            data: [
                { pergunta: "As trabalhadoras mulheres recebem o mesmo salário que os homens para executar a mesma função ou tarefa?", resposta: "Sim ou não"},
                { pergunta: "As trabalhadoras grávidas ou que amamentam são removidas de situações insalubres e colocadas em atividades de menor risco potencial à sua saúde e ao bebê?", resposta: "Sim ou não"},
                { pergunta: "São permitidas pausas para amamentação ou existe algum tipo de suporte para lactantes e/ou seus filhos?", resposta: "Sim ou não"},
                { pergunta: "As trabalhadoras têm pausas programadas ao realizar atividades com longos períodos de imersão ou exposição a água e/ou ao frio?"
                    , resposta: "Sim ou não" },
                { pergunta: "O transporte manual de cargas efetuado por mulheres e jovens é inferior àquele admitido para homens?"
                        , resposta: "Sim ou não"},
                { pergunta: "Há acesso a banheiro limpo e em condições de uso, sempre que preciso, durante o horário de trabalho?"
                    , resposta: "Sim ou não"},

            ],
        }
    }

    handleDownloadPDF = () => {

        window.scrollTo(0,0);

        html2canvas(document.querySelector('#printDiv'), {  allowTaint: true,
            useCORS: true,
            logging: false,
            height: window.outerHeight + window.innerHeight,
            windowHeight: window.outerHeight + window.innerHeight, }).then( function (canvas){


            const imgData = canvas.toDataURL("image/png", 1.0);


            const pdf = new jsPDF("p", "mm", "a4");

            pdf.addImage(imgData, 'PNG', 0,0);
            pdf.save("Checklist.pdf");
        })
    };

    /*** mulher ***/

    showDiv37 = (e) => {
        this.setState({
            showComponent37: e.target.checked,
        });
    };

    showDiv38 = (e) => {
        this.setState({
            showComponent38: e.target.checked,
        });
    };

    showDiv39 = (e) => {
        this.setState({
            showComponent39: e.target.checked,
        });
    };

    showDiv40 = (e) => {
        this.setState({
            showComponent40: e.target.checked,
        });
    };


    showDiv41 = (e) => {
        this.setState({
            showComponent41: e.target.checked,
        });
    };


    showDiv42 = (e) => {
        this.setState({
            showComponent42: e.target.checked,
        });
    };


    handleChangeDatePicker = date => {
        this.setState({
            startDate: date
        });
    };


    render(){

        const intl= this.props.intl;

        const placeholder = intl.formatMessage({id: 'ph.checklist1', defaultMessage: 'Nome do responsável'});
        const placeholder2 = intl.formatMessage({id: 'ph.checklist2', defaultMessage: 'Data de inspeção:'});
        const placeholder3 = intl.formatMessage({id: 'ph.checklist3', defaultMessage: 'Insira ação corretiva'});


        return(
            <Card>

                <Row>
                    <div className={"text-center"} align="center">
                        <img src={law} className={"img"} alt={"Woman health laws logo"} width={"100"} height={"100"}/>
                    </div>
                </Row>

                <div id={"printDiv"}>
                    <div align={"center"}>
                    <h5><b><FormattedMessage id={"women.ch"} defaultMessage={"Checklist Saúde da Mulher"}/></b></h5>
                    </div>
                    <input type={"text"} placeholder={placeholder} key={"nome"} />

                <React.Fragment>{

                    intl.locale==="en" ?

                        <DatePicker placeholderText={placeholder2} key={"data"}   selected={this.state.startDate}

                                    onChange={this. handleChangeDatePicker}/> :

                        <DatePicker locale={"pt"}  dateFormat="dd/MM/yyyy" placeholderText={placeholder2} key={"data"}   selected={this.state.startDate}

                                    onChange={this. handleChangeDatePicker}/>
                }</React.Fragment>

                    <div className={"margin"}>
                        <b><FormattedMessage id={"women.ch"} defaultMessage={"Checklist Saúde da Mulher"}/></b></div>

                    <div className={"woman1"}>

                        <form action={"#"} className={"formsWorks"}>

                            <p><FormattedMessage id={"women.ch1"} defaultMessage={"As trabalhadoras mulheres recebem o mesmo salário que os homens para executar a mesma função ou tarefa?"}/>
                            </p>

                            <input type={"checkbox"} id={"yes37"}/>

                            <label htmlFor={"yes37"} ><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                            <div>
                                <input type={"checkbox"} id={"no37"} onClick={this.showDiv37}/>

                                <label htmlFor={"no37"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                            </div>
                            {this.state.showComponent37 ?
                                <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }


                        </form>
                    </div>

                    <div className={"woman2"}>
                        <form action={"#"}>

                            <p><FormattedMessage id={"women.ch2"} defaultMessage={"As trabalhadoras grávidas ou que amamentam são removidas de situações insalubres e colocadas em atividades de menor risco potencial à sua saúde e ao bebê?"}/>
                            </p>

                            <input type={"checkbox"} id={"yes38"}/>

                            <label htmlFor={"yes38"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                            <div>
                                <input type={"checkbox"} id={"no38"} onClick={this.showDiv38}/>

                                <label htmlFor={"no38"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                            </div>
                            {this.state.showComponent38 ?
                                <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }
                        </form>
                    </div>

                    <div className={"woman39"}>
                        <form action={"#"}>

                            <p><FormattedMessage id={"women.ch3"} defaultMessage={"São  permitidas pausas para amamentação ou existe algum tipo de suporte para lactantes e/ou seus filhos?"}/></p>

                            <input type={"checkbox"} id={"yes39"}/>

                            <label htmlFor={"yes39"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                            <div>
                                <input type={"checkbox"} id={"no39"} onClick={this.showDiv39}/>

                                <label htmlFor={"no39"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                            </div>
                            {this.state.showComponent39 ?
                                <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }
                        </form>
                    </div>

                    <div className={"woman4"}>
                        <form action={"#"}>

                            <p><FormattedMessage id={"women.ch4"} defaultMessage={"As trabalhadoras têm pausas programadas ao realizar atividades com longos períodos de imersão ou exposição a água e/ou ao frio?"}/>
                            </p>

                            <input type={"checkbox"} id={"yes40"}/>

                            <label htmlFor={"yes40"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                            <div>
                                <input type={"checkbox"} id={"no40"} onClick={this.showDiv40}/>

                                <label htmlFor={"no40"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                            </div>
                            {this.state.showComponent40 ?
                                <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }
                        </form>
                    </div>

                    <div className={"woman5"}>
                        <form action={"#"}>

                            <p><FormattedMessage id={"women.ch5"} defaultMessage={"O transporte manual de cargas efetuado por mulheres e jovens é inferior àquele admitido para homens?"}/>
                            </p>

                            <input type={"checkbox"} id={"yes41"}/>

                            <label htmlFor={"yes41"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                            <div>
                                <input type={"checkbox"} id={"no41"} onClick={this.showDiv41}/>

                                <label htmlFor={"no41"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                            </div>
                            {this.state.showComponent41 ?
                                <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }

                        </form>
                    </div>

                    <div className={"woman6"}>
                        <form action={"#"}>

                            <p><FormattedMessage id={"women.ch6"} defaultMessage={"Há acesso a banheiro limpo e em condições de uso, sempre que preciso, durante o horário de trabalho?"}/>
                            </p>

                            <input type={"checkbox"} id={"yes42"}/>

                            <label htmlFor={"yes42"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                            <div>
                                <input type={"checkbox"} id={"no42"} onClick={this.showDiv42}/>

                                <label htmlFor={"no42"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                            </div>
                            {this.state.showComponent42 ?
                                <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }

                        </form>
                    </div>
                </div>

                <br/>

                <Button className={"button"} onClick={this.handleDownloadPDF} >
                    PDF
                </Button>


                <CSVLink data={this.state.data} separator={";"} filename={"checklist.csv"}>
                    <Button className={"button"}>
                        CSV
                    </Button> </CSVLink>

            </Card>
        )}

}

export default injectIntl(ChecklistMulher);

